import { render, staticRenderFns } from "./paperdispatch.vue?vue&type=template&id=767c5446&scoped=true&"
import script from "./paperdispatch.vue?vue&type=script&lang=js&"
export * from "./paperdispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767c5446",
  null
  
)

export default component.exports